(function () {
  const STORAGE_KEY = 'collectionView';

  function applyView(view) {
    const grid = document.getElementById('product-grid');
    if (!grid) return;

    // Set data-view on the grid
    grid.dataset.view = view;

    // Toggle aria state on buttons
    document.querySelectorAll('.view-toggle').forEach(btn => {
      btn.setAttribute('aria-pressed', btn.dataset.view === view);
    });




    // ADD / REMOVE CLASS ON PRODUCT CARDS
    // document
    //   .querySelectorAll('.card.card--standard, .grid__item, .card-wrapper')
    //   .forEach(el => {
    //     el.classList.toggle('is-list-view', view === 'list');
    //     // el.classList.toggle('hello', view === 'list');
    //   });



    // ADD / REMOVE CLASS ON PRODUCT CARDS
    const isList = view === 'list';
    const toggles = [
      {
        selector: '.card.card--standard, .grid__item, .card-wrapper',
        className: 'is-list-view'
      },
      {
        selector: '.card__inner',
        className: 'grid__inner'
      },
      {
        selector: '.card__content',
        className: 'grid__content'
      },
      {
        selector: '.product-title',
        className: 'hidden'
      },
      {
        selector: '.js_capture',
        className: 'list_view_info'
      },
      {
        selector: '.item_js_capture',
        className: 'item_borders_grid'
      },
      {
        selector: '.featured-button.quick-add__submit.button',
        className: 'list__position'
      },
      {
        selector: '.quick-add.no-js-hidden',
        className: 'list__position__btn_container'
      }
      

      
    ];

    toggles.forEach(({ selector, className }) => {
      document
        .querySelectorAll(selector)
        .forEach(el => el.classList.toggle(className, isList)
      );
    });


    // Product Title toggle
    // SHOW full title in list view
    document
      .querySelectorAll('.product-title-grid')
      .forEach(el =>
        el.classList.toggle('hidden', !isList)
      );

    // HIDE short title in list view
    document
      .querySelectorAll('.product-title')
      .forEach(el =>
        el.classList.toggle('hidden', isList)
      );




       
  }

  function initViewToggle() {
    const buttons = document.querySelectorAll('.view-toggle');
    if (!buttons.length) return;

    const savedView = localStorage.getItem(STORAGE_KEY) || 'grid';
    applyView(savedView);

    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        const view = btn.dataset.view;
        localStorage.setItem(STORAGE_KEY, view);
        applyView(view);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initViewToggle);
  document.addEventListener('shopify:section:load', initViewToggle);
})();
